var $table;
var pageSize;
var pageIndex;

$(document).ready(function(){
	
	$table = $("#link-table");
	pageSize = 50;
	pageIndex = 0;
	
	refreshTable();
	
	$(".pager-list").on("click","a.page",function(){
		
		var pIndex = parseInt($(this).html()) - 1;
		
		pageIndex = pIndex;
		refreshTable();
		
	});
	
	$(".pager-prevnext.prev").click(function(){
			
			if(pageIndex != 0){
				pageIndex--;
				refreshTable();
			}
			
		});
	
	$(".pager-prevnext.next").click(function(){
		var resultCount = $('#link-table').find("tr[data-visible=true][gr=a]").length;
		if(resultCount/pageSize > pageIndex+1 ){
			pageIndex++;
			refreshTable();
		}
		
	});
	$( document ).on( "flight_filter_event", function( event ) {
		pageIndex=0;
		refreshTable();
	})
});

function getVisibleFlightCount(){
	return $table.find("tr[data-visible=true][gr=a]").length;
}

function refreshTable(){
	$("#pager-totalResult").text(getVisibleFlightCount());	
	$table.find("tr[gr=a],tr[gr=b]").hide();
	$table.find("tr[data-visible=true][gr=a]").slice(pageSize * pageIndex,pageSize * (pageIndex + 1)).show();
	
	var pageNum = Math.ceil($table.find("tr[data-visible=true][gr=a]").length / pageSize);
	
	TABLE_PAGER.setPage(pageIndex, pageNum);	
}